import { graphql } from 'react-relay';

export const CommentsListFragment = graphql`
    fragment CommentsListFragment on Query
    @argumentDefinitions(
        commentable_id: { type: "String!" }
        cursor: { type: "String" }
        count: { type: "Int", defaultValue: 3 }
        order_by: { type: "[String]", defaultValue: ["created_at desc"] }
    ) {
        comments(commentable_id: $commentable_id, after: $cursor, first: $count, order_by: $order_by)
            @connection(key: "CommentsQuery_comments") {
            edges {
                cursor
                node {
                    id
                    commentable_type
                    commentable_id
                    text
                    commentator {
                        id
                        name
                        first_name
                        last_name
                    }
                    created_at
                    updated_at
                }
            }
            pageInfo {
                hasNextPage
                endCursor
            }
            ...CommentsConnectionFragment
        }
    }
`;
